import React, { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import GoogleButton from "react-google-button";
import {
    GoogleAuthProvider,
    signInWithPopup,
} from "firebase/auth";
import axios from "axios";
import { api } from "../lib/api";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setError("");

        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate("/dashboard"); // change this route as needed
        } catch (err: any) {
            console.error(err);
            setError("Invalid email or password.");
        }
    }

    const handleGoogleSignIn = async () => {
        setError("");
        const provider = new GoogleAuthProvider();

        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;

            console.log("Google user:", user);

            await axios.post(api.registerAuthor(), {
                firebaseUid: user.uid,
                displayName: user.displayName,
                email: user.email,  // Could be null
            });

            navigate("/feed");
        } catch (err: any) {
            setError(err.message || "Google sign-in failed");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <form
                onSubmit={handleLogin}
                className="bg-white shadow-md rounded-xl p-8 w-full max-w-sm"
            >
                <h2 className="text-2xl font-bold mb-6 text-purple-700 text-center">Log In</h2>
                {error && <p className="text-red-500 mb-4 text-sm text-center">{error}</p>}
                <input
                    type="email"
                    placeholder="Email"
                    className="w-full p-3 mb-4 border border-gray-300 rounded"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Password"
                    className="w-full p-3 mb-6 border border-gray-300 rounded"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <button
                    type="submit"
                    className="w-full bg-purple-600 text-white p-3 mb-4 rounded hover:bg-purple-700"
                >
                    Log In
                </button>
                <GoogleButton onClick={handleGoogleSignIn} />
            </form>
        </div>
    );
};

export default Login;
